const main = {
  container: '1366px',
  titles: {
    font: 'Simplon',
    color: '#000',
  },
  buttons: {
    font: {
      family: 'Simplon',
      weight: 'Medium',
    },
  },
  colors: {
    primary: '#d82482',
    secondary: '#51beb9',
    success: '#009DF7',
    error: '#f8562c',
    warning: '#f8562c',
    info: '#909090',
    light: '#f5f5f5',
    dark: '#222222',
    link: '#d82482',
    white: '#fff',
    black: '#000',
    danger: '#f8562c',
  },
  gradients: {
    success: {
      from: '#07CC14',
      to: '#61cc66',
    },
    error: {
      from: '#ca3a48',
      to: '#ca665e',
    },
    warning: {
      from: '#cc743c',
      to: '#cc9a67',
    },
    info: {
      from: '#009DF7',
      to: '#75c8f7',
    },
  },
};

export { main };
